import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import StellaLogo from "../components/StellaLogo";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDelivery(data?.email_delivery || null);
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F5] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center text-indigo-700 mb-6">
          <StellaLogo className="w-8 h-8" />
          <span className="text-2xl font-extrabold tracking-tight text-slate-900">Stella</span>
        </div>
        <div className="bg-white border border-[#E5E4DE] rounded-2xl shadow-[0_2px_12px_rgba(15,23,42,0.04)] p-6 sm:p-8">
          <h1 className="text-xl font-bold text-slate-900">Reset your password</h1>
          {submitted ? (
            <div className="mt-4 space-y-3">
              <p className="text-sm text-slate-600">
                If an account exists for that email, we've prepared a reset. Check your inbox.
              </p>
              {delivery === "setup_required" && (
                <div className="rounded-lg border border-amber-200 bg-amber-50 text-amber-900 text-xs p-3">
                  Email delivery: setup required. An administrator must add SENDGRID_API_KEY before reset emails can be sent.
                </div>
              )}
              <Link to="/login" className="text-xs text-indigo-700 hover:text-indigo-900" data-testid="back-to-login">← Back to sign in</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-5 space-y-3">
              <div>
                <label className="text-xs font-medium text-slate-600">Email</label>
                <Input
                  type="email" required
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email"
                  className="mt-1 h-11"
                />
              </div>
              <Button type="submit" disabled={submitting}
                      data-testid="forgot-submit"
                      className="w-full h-11 bg-indigo-700 hover:bg-indigo-800 text-white rounded-xl">
                {submitting ? "Sending..." : "Send reset link"}
              </Button>
              <div className="text-center">
                <Link to="/login" className="text-xs text-indigo-700 hover:text-indigo-900">← Back to sign in</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
